/* Factories */
import { createUnstackedLayout } from "./factories/complexLayoutFactory";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { LayoutProps } from "src/shared/interfaces/common/Layout";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";

const getComplexLayout = (
  type: ChartType[][],
  data: BaseChartProps<
    TreatmentPatternsProps[],
    ChartType[][]
  >
): LayoutProps => {
  const rows = type.flatMap((typeArray, outerIndex) => {
    const uniqueTypes = [...new Set(typeArray)];
    return uniqueTypes.map((type) => ({
      cols: createUnstackedLayout(type, outerIndex, data),
    }));
  });
  return { rows };
};

export default getComplexLayout;
